import { Injectable, TemplateRef } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ComponentType } from '@angular/cdk/overlay';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root' // dialog service, basically wrapper on mat-dialog
})
export class DialogService {
  constructor(
    private dialog: MatDialog
  ) { }

  // pass here component (you can find use case in header component ) or template ref # (use case in emergency contact component)
  public open<T>(component: ComponentType<T> | TemplateRef<T>, data: any): any {
    return this.dialog.open(component, {
      hasBackdrop: data.hasBackdrop ?? true,
      height: data.height ? data.height : '600',
      width: data.width ? data.width : '400',
      panelClass: data.panelClass ? data.panelClass : '',
      data: { 
        positionRelativeToElement: data.positionRelativeToElement ? data.positionRelativeToElement : null,
        authorizedUser: data.authorizedUser
      }
    });
  }

  public show<T>(dialogComponent: ComponentType<T> | TemplateRef<T>, data: any): Observable<T> {
    return this.open<T>(dialogComponent, data).afterClosed();
  }
}
